import { ConversationTurnRouting } from "../types";

export function isExactNear(routing?: ConversationTurnRouting): boolean {
  return routing != null && [ConversationTurnRouting.Exact, ConversationTurnRouting.Near].includes(routing);
}

export function isKeyword(routing?: ConversationTurnRouting): boolean {
  return routing === ConversationTurnRouting.Keyword;
}

export function isNoMatch(routing?: ConversationTurnRouting): boolean {
  return routing === ConversationTurnRouting.NoMatch;
}
